import React from "react";
import { useHistory } from "react-router-dom";
import "./Footer.scss";

const Footer = () => {
	const history = useHistory();
	return (
		<footer className="footer">
			<h2 className="footer__title">Celular Fire</h2>
			<div className="footer__content">
				<div className="footer__menu">
					<ul>
						<h4>Menú:</h4>
						<li>
							<button onClick={() => history.push("/")}>Inicio</button>
						</li>
						<li>
							<button onClick={() => history.push("/catalogo")}>Catálogo digital</button>
						</li>
						<li>
							<button onClick={() => history.push("/sucursales")}>Sucursales</button>
						</li>
						<li>
							<button onClick={() => history.push("/sobre-nosotros")}>Sobre nosotros</button>
						</li>
					</ul>
				</div>
				<div className="footer__regulaciones">
					<h4>Regulaciones:</h4>
					<button onClick={() => history.push("/terminos-y-condiciones") } >Términos y Condiciones</button>
				</div>
				<div className="footer__contacto">
					<h4>Contacto:</h4>
					<a href="https://wa.me/523315344361">
						<i className="fontIcons fontIcon--whatsapp" /> 3315344361
					</a>
					<a href="https://www.facebook.com/CelularFire" target="_blank">
						<i className="fontIcons fontIcon--facebook" /> Celular Fire
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
